import React from 'react';
import { Field, Form, Formik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { find } from 'lodash';
import { TextInput } from '../utils/forms/TextInput';
import { auth } from '../../actions/authenticationActions';
import { DEFAULT_ROUTE, SIGN_POST_ROUTE } from '../router/routes';
import FormGroup from '../Formik/FormGroup';
import { Submit } from '../Formik/Submit';
import { getUserPlaces } from '../../actions/parkingSpotActions';

function LoginPage() {
  const isLogged = useSelector((state) => state.auth.jwtToken !== null);
  const dispatch = useDispatch();
  const history = useHistory();
  const validationSchema = yup.object().shape({
    email: yup.string().trim().required('Login musí být vyplněn.'),
    password: yup.string().trim().required('Heslo musí být vyplněno.')
  });
  async function handleSubmit(values, actions) {
    try {
      await dispatch(auth(values.email, values.password));
    } catch (err) {
      actions.setFieldError(
        'password',
        'Bylo zadáno špatný přístupový login nebo heslo.'
      );
    }
  }

  if (isLogged) {
    dispatch(getUserPlaces()).then(() => {
      history.push(DEFAULT_ROUTE);
    });
  }

  return (
    <div className="pl3 pr3">
      <Formik
        initialValues={{
          email: '',
          password: ''
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit: onClick }) => (
          <div>
            <form>
              <FormGroup>
                <Field
                  name="email"
                  component={TextInput}
                  label="Login"
                  type="text"
                />
              </FormGroup>
              <FormGroup>
                <Field
                  name="password"
                  component={TextInput}
                  label="Heslo"
                  type="password"
                />
              </FormGroup>
              <FormGroup>
                <div className="center mt3">
                  <Submit value="Přihlásit se" onClick={onClick} />
                </div>
              </FormGroup>
            </form>
          </div>
        )}
      </Formik>
    </div>
  );
}

export default LoginPage;
